import { render } from "./DetailTelerehap.vue?vue&type=template&id=7704c06b&scoped=true"
import script from "./DetailTelerehap.vue?vue&type=script&lang=js"
export * from "./DetailTelerehap.vue?vue&type=script&lang=js"

import "./DetailTelerehap.vue?vue&type=style&index=0&id=7704c06b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7704c06b"

export default script